import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    message: { type: String, default: 'Your submission is still in progress. Are you sure you want to leave?' }
  }

  connect() {
    this.bypass = false
    this.suppressPopState = false

    window.addEventListener('turbo:before-visit', this.handleBeforeVisit)
    window.addEventListener('beforeunload', this.handleBeforeUnload)
    window.addEventListener('unsaved-changes:remove', this.handleBypass)
    document.addEventListener('click', this.handleBypassClick, true)
  }

  disconnect() {
    window.removeEventListener('turbo:before-visit', this.handleBeforeVisit)
    window.removeEventListener('beforeunload', this.handleBeforeUnload)
    window.removeEventListener('unsaved-changes:remove', this.handleBypass)
    document.removeEventListener('click', this.handleBypassClick, true)
  }

  handleBypass = () => {
    this.bypass = true
  }

  handleBypassClick = event => {
    if (event.target.closest('[data-grid-bypass-unsaved]')) {
      this.bypass = true
    }
  }

  handleBeforeVisit = event => {
    if (this.bypass) return
    // Same-URL visits are page refreshes triggered by user actions on this page
    // (e.g. submitting the Add-to-slate form returns a turbo_stream refresh) —
    // not navigation away, so don't prompt.
    if (event.detail?.url === window.location.href) return
    if (!window.confirm(this.messageValue)) event.preventDefault()
  }

  handleBeforeUnload = event => {
    if (this.bypass) return
    event.preventDefault()
    // Browsers require both preventDefault() and setting returnValue to show the dialog
    event.returnValue = ''
  }
}
